import { render, staticRenderFns } from "./PanelPromoteCompetition.vue?vue&type=template&id=3575f0fa&scoped=true&"
import script from "./PanelPromoteCompetition.vue?vue&type=script&lang=js&"
export * from "./PanelPromoteCompetition.vue?vue&type=script&lang=js&"
import style0 from "./PanelPromoteCompetition.vue?vue&type=style&index=0&id=3575f0fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3575f0fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3575f0fa')) {
      api.createRecord('3575f0fa', component.options)
    } else {
      api.reload('3575f0fa', component.options)
    }
    module.hot.accept("./PanelPromoteCompetition.vue?vue&type=template&id=3575f0fa&scoped=true&", function () {
      api.rerender('3575f0fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PanelPromoteCompetition.vue"
export default component.exports